import React, { createContext, useContext } from 'react';
import HospitalMap from '../Components/HospitalMap/HospitalMap';

export default function Plan(props) {

    return (
        <>
            <main className="Map">
                <h1>Map</h1>

                <HospitalMap />

            </main>
        </>
    )
}